import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Button } from '@mui/material';
import AxiosInstance from '../../../server/AxioInstance';
import TableComponent from '../../common/table/Table';
import ApproveBotton from '../../common/approveBotton/ApproveBotton';

const columns = [
  { id: 'approve', label: 'Aprovador', align: 'left' },
  { id: 'date', label: 'Data', align: 'center' },
  { id: 'active', label: 'Ativo', aling: 'center' },
  { id: 'acao', label: 'Ação', align: 'center' },
];

const ApproveConsult = ({ handleChangeComponent }) => {
  const [rows, setRows] = useState([]);

  const handleConsultApprover = useCallback(async () => {
    const result = await AxiosInstance.get('/approve/consult-approver');
    const temp = result?.data?.rows?.map((item) => ({
      ...item,
      ativo: item.active ? 'ATIVADO' : 'DESATIVADO',
      acao: (
        <ApproveBotton
          // handleAction={handleAction}
          url="/approve/activator-approver"
          item={item}
          handleChangeComponent={handleChangeComponent}
          handleCosnult={handleConsultApprover}
          edit={false}
        />
      ),
    }));
    setRows(temp);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleConsultApprover();
  }, [handleConsultApprover]);

  return (
    <Box m={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={4}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleChangeComponent('Registrar novos aprovadores', 'create')}
          >
            cadastrar
          </Button>
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
          <TableComponent columns={columns} rows={rows} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApproveConsult;
